import HttpClient from '@/common/Http';
import apiConfig from '@/config';
import { Member } from '@/Member/member.entity';

export default class MemberService {
    private httpClient: HttpClient;

    constructor() {
        this.httpClient = new HttpClient('members');
    }

    async getConnectedMember(): Promise<Member> {
        return this.httpClient.get<Member>('/members/me');
    }

    /**
     * Force users to use php api to log in.
     */
    async logMemberIn(email: string, password: string): Promise<Member> {
        return this.httpClient.post<Member>(`${apiConfig.apiUrl}/auth/login`, { email, password });
    }

    async logMemberOut(): Promise<Member> {
        return this.httpClient.post<Member>('/auth/logout');
    }

    async find(memberId: string): Promise<Member> {
        return this.httpClient.get<Member>(`/members/${memberId}`);
    }

    async findAll(): Promise<Member[]> {
        return this.httpClient.get<Member[]>('/members');
    }

    /**
     * Who the current user may assign an analysis to in this litigation, ready to render as
     * received: the backend returns the litigation's active members (any role), puts the current
     * user first, and sorts the rest by name. A caller without the assign capability gets just
     * themselves back.
     */
    async findAssignable(litigationId: string): Promise<Member[]> {
        return this.httpClient.get<Member[]>(`/litigations/${litigationId}/assignable-analysts`);
    }

    async create(data: Pick<Member, 'email' | 'firstName' | 'lastName' | 'role'>): Promise<Member> {
        return this.httpClient.post<Member>('/members', data);
    }

    public update(memberId: string, member: Member): Promise<Member> {
        return this.httpClient.put<Member>(`/members/${memberId}`, member);
    }

    async requirePasswordReset(memberId: string): Promise<Member & { password: string }> {
        return this.httpClient.post<Member & { password: string }>(`/members/${memberId}/require-password-reset`);
    }

    async resetPassword(newPassword: string): Promise<void> {
        return this.httpClient.put<void>(`/members/me/password`, { plainPassword: newPassword });
    }
}
